import { Card } from "primereact/card";
import { useState } from "react";
import { Calendar } from "primereact/calendar";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";

ChartJS.register(ArcElement, Tooltip);

const TreatmentAreasCard = ({t} :any) => {
    const today = new Date();
    const [treatmentAreaPlanDate, setTreatmentAreaPlanDate] = useState<any>(today)
    const sixMonthAgo = new Date(today.getFullYear(), today.getMonth() - 5, 1);
    
    const data = {
        datasets: [
            {
                data: [0, 100],
                backgroundColor: ["#6383F4", "#E0E3EE"],
                borderWidth: 4,
                cutout: "50%",
                circumference: 180,
                rotation: 270,
                borderRadius: 10
            },
            {
                data: [0, 100],
                backgroundColor: ["#64ADF0", "#E0E3EE"],
                borderWidth: 7,
                cutout: "40%",
                circumference: 180,
                rotation: 270,
                borderRadius: 10
            },
            {
                data: [0, 100],
                backgroundColor: ["#8569D5", "#E0E3EE"],
                borderWidth: 7,
                cutout: "40%",
                circumference: 180,
                rotation: 270,
                borderRadius: 10
            },
            {
                data: [0, 100],
                backgroundColor: ["#EE7572", "#E0E3EE"],
                borderWidth: 7,
                cutout: "40%",
                circumference: 180,
                rotation: 270,
                borderRadius: 10
            },
        ],
    };

    const options: any = {
        responsive: true,
        maintainAspectRatio: false,
        hover: {
            mode: null,
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        layout: {
            padding: {
                top: 40,
                bottom: 0,
                left: 0,
                right: 20
            }
        }
    };

    return (
        <div className='col'>
            <Card className="h-16rem" style={{ borderRadius: "24px", position: "relative" }}>
                <div className='flex flex-column gap-2'>
                    <div className='flex justify-content-between align-items-center'>
                        <p className='m-0 text-lg' style={{ color: '#727A99' }}>{t("treatmentAreasOfPatients")}</p>
                        <Calendar style={{ width: "7rem", height: "2rem" }} value={treatmentAreaPlanDate} minDate={sixMonthAgo}
                            maxDate={today}
                            onChange={(e) => setTreatmentAreaPlanDate(e.value)} view="month" dateFormat="M yy" />
                    </div>
                    <div className='flex justify-content-between align-items-end'>
                        <div style={{ position: "relative", width: '15rem', height: '10rem' }}>
                            <Doughnut data={data} options={options} />
                        </div>
        
                        <div className="flex flex-column gap-2">
                            {[
                                { label: t('shoulder'), count: 0, color: "#6383F4" },
                                { label: t('neck'), count: 0, color: "#64ADF0" },
                                { label: t('backBody'), count: 0, color: "#8569D5" },
                                { label: t('knee'), count: 0, color: "#EE7572" },
                            ].map((item, index) => (
                                <div key={index} className="flex justify-content-between align-items-center gap-4">
                                    <div className="flex justify-content-center align-items-center gap-2">
                                        <span style={{
                                            width: '0.5rem',
                                            height: '0.5rem',
                                            backgroundColor: item.color,
                                            borderRadius: '50%',
                                        }}></span>
        
                                        <p className="m-0 text-sm" style={{ color: "#727A99" }}>{item.label}</p>
                                    </div>
                                    <p className="m-0 text-sm font-bold" style={{ color: "#2D3967", textAlign: "left", minWidth: "20px" }}>{item.count}%</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    )
}

export default TreatmentAreasCard;